import { getPresignedUrlResponse } from '@services/common.services'
import { createContext } from 'react'
import { DialogOptions } from './types'

export default createContext<
  (options: DialogOptions) => Promise<getPresignedUrlResponse> | any
>(() => null)
